<template>
  <b-container v-if="errored" class="section" fluid>
    <p>{{ translation }}</p>
  </b-container>
  <b-container v-else class="section" fluid>
    <b-row v-if="loading">
      <b-spinner style="width: 3rem; height: 3rem; color:#1702f8; margin: auto;" label="Large Spinner"
        type="grow"></b-spinner>
    </b-row>
    <b-row v-else>
      <b-col cols="12" v-for="(item, index) in articles" :key="index" class="U--p--0">
        <BabillardListItemComponent :title="item.trans[0].title" :content="item.trans[0].description" :img="item.image"
          :url="item.website" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue';
import BabillardListItemComponent from './BabillardListItemComponent.vue';
import httpClient from '@/Api/HttpClient';

defineProps({
  translation: {
    type: String,
    required: true
  }
});
const articles = ref<any[]>([]);
const errored = ref(false);
const loading = ref(true);
const currentDate = new Date(Date.now()).toISOString();

onMounted(() => {
  httpClient
    .get('/publications')
    .then(response => {
      articles.value = response.data.publications.filter((item: any) => item.statusId === 3 && item.dateFrom <= currentDate);
    })
    .catch(() => {
      errored.value = true;
    })
    .finally(() => {
      loading.value = false;
    });
});

</script>